export class KeycloakCodes {
  constructor(public codeVerifier: string, public challenge: string) {}
}



// WEBPACK FOOTER //
// ./src/app/models/keycloak-codes.model.ts